export class CatalogProduct {
    bundle: boolean;
    category: string;
    checkAction: string;
    description: string;
    displayName: string;
    documentations: CatalogProductDocumentation = new CatalogProductDocumentation();
    eccn: string;
    enableHotfixes: boolean;
    enableLanguages: boolean;
    expand: boolean;
    manufacturer: string;
    patchFolder: string;
    productComponents: ProductComponents;
    //prerequisites:
    productName: string;
    product_uid: string;
    releaseTimestamp: Date;
    supportsHotfixes: boolean;
    supportsLanguages: boolean;
    version: string;
    selected: boolean;
    isSap: boolean;
    sapName: string;
    languagePackages: LanguagePack[];
}

export class CatalogProductDocumentation {
    documentation: string;
    releaseNotes: string;
}

export class CatalogTreeProduct {
    expand: boolean;
    majorVersionDots: number;
    manufacturer: string;
    product_name: string;
    isSap: boolean;
    sapName: string;
    productVersions:CatalogProduct[];
}

export class CatalogProductDependency {
    additionalRequirements: string;
    bundle: boolean;
    category: string;
    displayName: string;
    local: boolean;
    lowestSupported: string;
    lowestUnsupported: string;
    manufacturer: string;
    optional: boolean;
    productName: string;
    uid: string;
    version: string;
}

export class ProductComponents{
    productComponent: ProductComponent[];
}

export class ProductComponent{
    checkAction: string;
    componentuid: string;
    dependencies: CatalogProductDependency[];
    description: string;
    displayName: string;
    functionalGroup: string;
    language: string;
    optional: boolean;
    productBinaries: ProductBinaries;
    setupId: string;
    supportedPlatforms: CatalogProductDependency[];
    version: string;
}

export class ProductBinaries{
    productBinary: ProductBinary[];
}

export class ProductBinary{
    algorithm: string;
    binaryuid: string;
    checksum: string;
    description: string;
    displayName: string;
    downloadURL: string;
    filename: string;
    hashcode: string;
    downloadStatus: any;
    isDownloaded: boolean;
    isDownloading: boolean;
    prerequisites: BinaryPrerequisites;
    size: number
    isLang: boolean;
    updateBinaryUID: string;
}

export class BinaryPrerequisites{
    requiredProductComponent: CatalogProductDependency[];
    requiredProductVersion: CatalogProductDependency[];
}

export class LanguagePack{
    binaryuid: string;
    displayName:string;
    downloadURL: string;
    fileName: string;
    hashcode: string;
    isDownloaded: boolean;
    langCode: string;
    langName: string;
    langpackDBId: number;
    name: string;
    size: number
    unCompressedSize: number;
    status:string;
    selected: boolean;
    updateBinaryUID: string;
}

export class BinaryDownload{
    productName: string;
    productuid: string;
    componentName: string;
    componentuid: string;
    binaryName: string;
    binaryuid: string;
    version: string;
    size: number;
    os: string;
    url: string;
    binary: ProductBinary;

    constructor(productName: string, productuid: string, componentName: string, componentuid: string, binaryName: string, binaryuid: string, 
        version: string, size: number, os: string, url: string, binary: ProductBinary){
        
        this.productName = productName;
        this.productuid = productuid;
        this.componentName = componentName;
        this.componentuid = componentuid;
        this.binaryName = binaryName;
        this.binaryuid = binaryuid;
        this.version = version;
        this.size = size;
        this.os = os;
        this.url = url;
        this.binary = binary;
    }
}